import { Inmate } from '@reliance/types/models/Inmate';
import {
  Outlet,
  type LoaderFunctionArgs,
  type RouteObject,
  type UIMatch,
} from 'react-router-dom';
import api from '../common/api';
import { formatFullName } from '../format/FullName';
import { lazyElement } from '../routing/lazyRoute';
import InmateList from './list/List';
import InmateDetailView from './detail-view/InmateDetailView';

const inmateRoutes: RouteObject[] = [
  {
    path: '/inmates',
    element: <Outlet />,
    handle: {
      documentTitle: 'Inmates',
      crumb: () => ({ label: 'Inmates', to: '/inmates' }),
    },
    children: [
      { index: true, element: <InmateList /> },
      {
        path: 'view/:id',
        element: <InmateDetailView />,
        loader: async ({ params }: LoaderFunctionArgs) => {
          const id = Number(params.id);
          if (!Number.isFinite(id) || id <= 0) {
            throw new Response('Invalid inmate id', { status: 400 });
          }
          try {
            const res = await api.get<Inmate>(
              `/inmate/by-id/${id}?includeDisabled=true`,
            );
            return res.data;
          } catch (e: unknown) {
            const status = (e as { response?: { status?: number } })?.response
              ?.status;
            if (status === 404) {
              throw new Response(`Inmate with ID ${id} not found`, { status: 404 });
            }
            throw e;
          }
        },
        handle: {
          crumb: (match: unknown) => {
            const inmate = (match as UIMatch).data as Inmate | undefined;
            const label = inmate
              ? `${formatFullName(inmate)} (#${inmate.account})`
              : 'Inmate';
            return {
              label,
              to: inmate ? `/inmates/view/${inmate.id}` : undefined,
            };
          },
        },
      },
      {
        path: 'blacklist',
        element: lazyElement(() => import('../inmate-device-blacklist/List')),
        handle: {
          documentTitle: 'Inmate Device Blacklist',
          crumb: () => ({ label: 'Inmate Device Blacklist', to: '/inmates/blacklist' }),
        },
      },
    ],
  },
];

export default inmateRoutes;
